import React, { FC, ReactElement } from 'react';

import { Offer } from '@/interfaces';
import { formatReadableDateShort, formatReadableTime, safeParseISO } from 'shared/util/datetime-fns';

export type OfferFlight = Pick<Offer, 'departureDate' | 'returnDate'>;

export const Flight: FC<OfferFlight> = ({ departureDate, returnDate }): ReactElement<OfferFlight> => {
    const parsedDepartureDate = safeParseISO(departureDate);
    const parsedReturnDate = safeParseISO(returnDate);

    const renderDateTime = (dateTime: Date): ReactElement => (
        <span className="u-float-left u-text-center">
            <div className="capitalize u-d1 u-strong" data-testid="date">
                {formatReadableDateShort(dateTime)}
            </div>
            <div className="text--extra-small" data-testid="time">
                kl. {formatReadableTime(dateTime)}
            </div>
        </span>
    );

    return (
        <>
            <span className="icon-pre icon--flight-departure u-float-left" />
            <span data-testid="departureDate">{parsedDepartureDate && renderDateTime(parsedDepartureDate)}</span>
            <span className="u-float-left u-mh8"> - </span>
            <span data-testid="returnDate">{parsedReturnDate && renderDateTime(parsedReturnDate)}</span>
        </>
    );
};
